import React, { useState, useEffect } from "react";
import { getIcons } from "../../Constant/Constant";

const icons = getIcons();

const LeadList = ({ totalLeads, mockLeads, fetchLeads ,handleSearchLead ,title}) => {
  const [leads, setLeads] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [nextPageId, setNextPageId] = useState(null);
  const [previousPageId, setPreviousPageId] = useState(null);
  const [pages, setPages] = useState([]);
  const [hasMoreLeads, setHasMoreLeads] = useState(true);

  console.log("Starting", mockLeads);
  useEffect(() => {
    if (!mockLeads) return; 
    setLoading(true);
    setTimeout(() => {
      if (mockLeads?.leads) {
        setLeads(mockLeads.leads);
        setNextPageId(mockLeads.next);
        setPreviousPageId(mockLeads.previous);
        setHasMoreLeads(!!mockLeads.next);

       
        const updatedPages = [...pages];
        updatedPages[currentPage - 1] = mockLeads.leads;
        setPages(updatedPages);
      }
      setLoading(false);
    }, 800);
  }, [mockLeads]);

  const handleSearchChange = () => {
    
     if(searchKey === "")
     {
      handleSearchLead(null)
     }
     else {
      handleSearchLead(searchKey)
     }
   
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearchChange();
    }
  };

  const handlePageChange = (pageId, direction) => {
    if (loading || !pageId) return;

    const newPage = direction === "next" ? currentPage + 1 : currentPage - 1;

    if (pages[newPage - 1]) {
      setLeads(pages[newPage - 1]);
      setCurrentPage(newPage);
    } else {
      setLoading(true);

      fetchLeads(pageId, direction)
        .then((newMockLeads) => {
          if (newMockLeads?.leads.length === 0) {
            setHasMoreLeads(false);
          } else {
            setLeads(newMockLeads.leads);
            setNextPageId(newMockLeads.next);
            setPreviousPageId(newMockLeads.previous);
            setHasMoreLeads(!!newMockLeads.next);
          }
        })
        .finally(() => setLoading(false));
    }
  };

  const handleLeadInfo = (lead) => {
    console.log("Lead selected:", lead);
  };

  return (
    <div className="mt-10 w-full bg-white rounded-lg shadow-md p-6">
      <div className="flex justify-between flex-col gap-5">
        <div className="flex">
          <h1 className="text-3xl font-semibold 3xl:text-4xl ml-5">
          {title || "All Leads"} &#40;{totalLeads}&#41;
          </h1>
        </div>

        <div className="relative">
          <input
            className="border-customGreen rounded-md border bg-transparent w-[70%] h-10 px-4 pl-10 mx-5 focus:outline-none"
            placeholder="Search by name or phone"
            type="search"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
            onKeyPress={handleSearchKeyPress}
          />
          <div className="absolute left-8 top-3 text-gray-400">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
          <button
            className="w-[20%] p-2 text-white h-10 bg-customGreen rounded-md"
            onClick={handleSearchChange}
          >
            Search
          </button>
        </div>
      </div>

      {/* Leads List */}
      <div className="overflow-y-auto custom-scrollbar h-[500px] bg-white py-5 px-5">
        {loading ? (
          <div className="flex justify-center items-center h-full">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-customGreen"></div>
          </div>
        ) : leads?.length === 0 ? (
          <div className="text-center text-gray-500">No leads to show.</div>
        ) : (
          leads?.map((lead) => (
            <div
              onClick={() => handleLeadInfo(lead)}
              key={lead.id || `${lead.name}-${lead.phoneNumber}`}
              className="grid grid-cols-2 gap-6 p-4 xl:px-5 mt-5 rounded-lg shadow-md cursor-pointer bg-white transition-shadow duration-300"
            >
              <div className="flex flex-col gap-2 w-5/12 xl:w-full">
                <h1
                  title={lead.name}
                  className="text-xl font-bold text-gray-800 truncate xl:text-base 4xl:text-2xl"
                >
                  {lead.name.replace(/\b\w/g, (char) => char.toUpperCase())}
                </h1>

                <p className="font-medium text-gray-600 text-sm">
                  <span className="truncate">
                    {lead.phoneNumber
                      ? `${lead.phoneNumber}`
                      : "+91 12345 67890"}
                  </span>
                </p>

                {lead?.userName && (
                  <div className="flex items-center gap-2">
                    <div className="font-semibold text-gray-700">
                      {lead.userName}
                    </div>
                  </div>
                )}

                {lead?.leadInterestedLocation?.length > 0 && (
                  <div className="border border-customGreen text-customGreen text-sm bg-green-100 rounded-full px-3 py-1 w-fit">
                    {lead.leadInterestedLocation[0]}
                  </div>
                )}
              </div>

              <div className="flex h-8 justify-end items-center">
                <div className="border border-blue-700 text-blue-700 text-sm bg-blue-100 rounded-full px-3 py-1">
                  {lead?.leadStatus}
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      <div className="flex justify-center my-5 gap-10">
  {(totalLeads > 10 && previousPageId) && currentPage !== 1 && (
    <button
      onClick={() => handlePageChange(previousPageId, "previous")}
      className={`mx-1 px-3 py-1 border rounded text-blue-500 ${
        !previousPageId || currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
      }`}
      disabled={!previousPageId || currentPage === 1}
    >
      <img src={icons.previousPagination} className="w-3" alt="Previous" />
    </button>
  )}

  <span>{currentPage}</span>

  {(totalLeads > 10 && hasMoreLeads) && (
    <button
      onClick={() => handlePageChange(nextPageId, "next")}
      className={`mx-1 px-3 py-1 border rounded text-blue-500 ${
        !hasMoreLeads ? "opacity-50 cursor-not-allowed" : ""
      }`}
      disabled={!hasMoreLeads}
    >
      <img src={icons.nextPagination} className="w-3" alt="Next" />
    </button>
  )}
</div>



    </div>
  );
};

export default LeadList;
